<template>
  <v-row>
    <v-col cols='12' v-if='wo.on_hold'>
      <v-alert
        border='top'
        icon='mdi-alert-octagon'
        colored-border
        type='error'
        class='mb-n2 pb-2 red lighten-5'
      >
        <span class='body-2 font-weight-bold pt-0 mr-3'>This work order has been placed on hold.<br>Please contact the office</span>
      </v-alert>
    </v-col>

    <v-col cols='12' v-if='!wo.is_complete && wo.call_mins_ahead'>
      <v-alert
        border='top'
        icon='mdi-phone'
        colored-border
        type='error'
        class='mb-n2 pb-2 red lighten-5'
      >
        <span class='body-2 font-weight-bold pt-0 mr-3'>{{ 'Call customer ' + wo.call_mins_ahead + ' mins before arrival.' }}</span>
        <span v-if='wo.call_mins_ahead_notes' class='body-2 font-weight-bold pt-0'>{{ wo.call_mins_ahead_notes }}</span>
      </v-alert>
    </v-col>

    <v-col v-if='wo.is_complete' cols='12'>
      <v-alert
        border='top'
        icon='mdi-alert'
        colored-border
        type='warning'
        class='mb-n2 pb-2 orange lighten-5'
      >
        <span class='body-2 font-weight-bold pt-0'>This Work Order is completed</span>
      </v-alert>
    </v-col>

    <v-col v-if='!wo.is_complete && wo.apt_time' cols='12'>
      <v-alert
        border='top'
        icon='mdi-timer-outline'
        colored-border
        type='error'
        class='mb-n2 pb-2 red lighten-5'
      >
        <span class='body-2 font-weight-bold pt-0'>{{ wo.apt_time | time }}</span>
        <span v-if='wo.apt_end' class='body-2 font-weight-bold pt-0'> - {{ wo.apt_end | time }}</span>
        <span class='body-2 font-weight-bold pt-0'> {{ wo.apt_end ? ' Apt. window' : ' Appointment' }}</span>
        <span class='body-2 font-weight-bold pt-0' v-if='wo.apt_notes' >{{ ' - ' + wo.apt_notes }}</span>
        <span class='body-2 font-weight-bold pt-0' v-if='wo.priority === 1'> - Should Do Today</span>
        <span class='body-2 font-weight-bold pt-0' v-if='wo.priority === 2'> - Must Do Today</span>
      </v-alert>
    </v-col>

    <v-col v-if='!wo.is_complete && wo.priority === 2 && !wo.apt_time' cols='12'>
      <v-alert
        border='top'
        colored-border
        type='error'
        class='mb-n2 pb-2 red lighten-5'
      >
        <span class='body-2 font-weight-bold pt-0'>Must do Today</span>
        <span class='body-2 font-weight-bold pt-0' v-if='wo.apt_notes' >{{ ' - ' + wo.apt_notes }}</span>
      </v-alert>
    </v-col>

    <v-col v-if='!wo.is_complete && wo.priority === 1 && !wo.apt_time' cols='12'>
      <v-alert
        border='top'
        colored-border
        icon='mdi-exclamation-thick'
        type='warning'
        class='mb-n2 pb-2 orange lighten-5'
      >
        <span class='body-2 font-weight-bold pt-0'>Should do Today</span>
        <span class='body-2 font-weight-bold pt-0' v-if='wo.apt_notes' >{{ ' - ' + wo.apt_notes }}</span>
      </v-alert>
    </v-col>

    <v-col cols='12' v-if='!wo.is_complete && outsideWarranty && !nonCapitalSystem'>
      <v-alert
        border='top'
        colored-border
        color='primary'
        type='info'
        class='mb-n2 pb-2 primary lighten-5'
      >
        <span class='body-2 font-weight-bold pt-0'>This system is outside of the warranty period.</span>
      </v-alert>
    </v-col>

    <v-col cols='12' v-if='!wo.is_complete && nonCapitalSystem'>
      <v-alert
        border='top'
        colored-border
        color='purple'
        type='info'
        class='mb-n2 pb-2 purple lighten-5'
      >
        <span class='body-2 font-weight-bold pt-0'>Non Capital Install</span>
      </v-alert>
    </v-col>
  </v-row>
</template>

<script>
import moment from 'moment'

export default {
  name: 'fc-alert-banners',
  props: {
    wo: {
      required: true
    },
  },
  data: () => ({

  }),
  computed: {
    nonCapitalSystem () {
      if (this.wo.project) {
        if (this.wo.project_obj.division_obj.division === 'Irrigation' &&
          this.wo.project_obj.project_detail &&
          !this.wo.project_obj.project_detail.is_capital_system) {
          return true
        }
      }
      return false
    },
    outsideWarranty () {
      if (this.wo.project && this.wo.project_obj.project_detail.install_date) {
        let fiveYearsAgo = moment().subtract(5, 'years')
        let oneYearAgo = moment().subtract(1, 'years')
        let overFive = moment(this.wo.project_obj.project_detail.install_date, 'YYYY-MM-DD').isBefore(fiveYearsAgo)
        let overOne = moment(this.wo.project_obj.project_detail.install_date, 'YYYY-MM-DD').isBefore(oneYearAgo)
        if (this.wo.project_obj.is_comm) {
          return (overOne || !this.wo.project_obj.project_detail.is_capital_system)
        }
        return (overFive || !this.wo.project_obj.project_detail.is_capital_system)
      }
      return false
    },
  },
  methods: {

  }
}
</script>